import * as React from "react";

const Disclosures = () =>  (
        <div className={"container-fluid body-content terms-container"}>
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-heading">Disclosure Statements</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p>We operate our provider referral service to assist patients in selecting providers who are members of the medical staff or allied health professional staff at one or more Scott & White Healthcare hospitals and/or employed by Scott & White Clinics. There are no charges to the providers or to you for this service. Referrals are provided on an all–inclusive basis using the preferences you indicate. Your selection of a provider should be based on your needs and preferences. If a provider leaves the medical staff or allied health professional staff at Scott & White and/or employment by Scott & White Clinics, we will no longer include that provider in our referral service. By using the provider referral service, you certify that you have received these disclosures. </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
);
export default Disclosures;